import { useState } from "react";
import { IDashCannedResponse, DashCannedResponseApi } from "@nkr/models/dash/dash-canned-response";
import { DashCannedResponsesGrid } from "../page-components/dash-canned-responses-grid";
import { DashCannedResponsesSidebar } from "../page-components/dash-canned-responses-sidebar";
import { Button, Glyphicon, Row, Col } from "react-bootstrap";


export const DashCannedResponses = () => {
    const [selectedRow, setSelectedRow] = useState<IDashCannedResponse | null>(null);
    const results                       = DashCannedResponseApi.useGetAll();

    return <>
        <Row style={{margin:"12px 0"}}>
            <Col xs={6}><h3 style={{ margin: 0 }}>DASH Canned Responses</h3></Col>
            <Col xs={6} style={{ textAlign: 'right' }}>
                <Button bsStyle="primary" onClick={() => setSelectedRow({ id: null, name: '', emailSubject: '', emailContent: '', type: 0 } as IDashCannedResponse)} style={{ marginLeft: 10 }}><Glyphicon glyph="plus" /> Add New</Button>
            </Col>
        </Row>

        {results?.isSuccess && results?.payload && (
            <DashCannedResponsesGrid data={results.payload} setSelectedRow={(selected: IDashCannedResponse) => setSelectedRow(selected)} />
        )}

        {selectedRow && (
            <DashCannedResponsesSidebar selected={selectedRow} setSelectedRow={(selected: IDashCannedResponse) => setSelectedRow(selected)} />
        )}
    </>;
};